import styles from './styles/SubItems.module.scss';
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import { useAlgoliaDataContext } from '../../../hooks/useAlgoliaDataContext';
import { useHierarchyContext } from '../../../hooks/useHierarchyContext';
import { getFilteredSubcollectionObjects } from '../../../utils/getFilteredSubcollectionObjects';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../../../constants/searchParamKeys';
import { dispatchGAEvent } from '../../../../events/dispatchGAEvent';
import { getLazyLinkToImage } from '../../../../js/helpers/getLazyLinkToImage';
import { useSEOKeywords } from '../../../hooks/useSEOKeywords';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
const getNumberOfItemsInRow = (items, hasViewAll) => {
    const fTop = items[hasViewAll ? 0 : 1].offsetTop;
    const btn = items[hasViewAll ? 1 : 0];
    let lastIndex = items.length - 1;
    let visibleItems = items.length - (hasViewAll ? 2 : 1);
    while (btn.offsetTop !== fTop) {
        items[lastIndex--].hidden = true;
        visibleItems--;
    }
    for (const item of items) {
        item.hidden = false;
    }
    return visibleItems;
};
export const SubItems = ({ itemHandles, viewAllObj }) => {
    const [searchParams] = useSearchParams();
    const [expanded, setExpanded] = useState(false);
    const [nbOfItemsInRow, setNbOfItemsInRow] = useState(0);
    const { kw1 } = useSEOKeywords();
    const { medium } = useParams();
    const { objects } = useHierarchyContext();
    const { facetsFromServer } = useAlgoliaDataContext();
    const containerRef = useRef(null);
    const items = useMemo(() => {
        setNbOfItemsInRow(0);
        return getFilteredSubcollectionObjects(itemHandles, facetsFromServer, objects);
    }, [itemHandles, facetsFromServer, objects]);
    useLayoutEffect(() => {
        if (MEDIA_BREAKPOINTS.XL_UP.matches &&
            nbOfItemsInRow === 0 &&
            containerRef.current !== null &&
            containerRef.current.children.length > 1) {
            setNbOfItemsInRow(getNumberOfItemsInRow(containerRef.current.children, viewAllObj !== undefined));
        }
    });
    searchParams.delete(SEARCH_PARAM_KEY_PAGE_NUMBER);
    const searchParamsStr = searchParams.toString();
    const itemsForRender = nbOfItemsInRow > 0 && !expanded
        ? items.slice(0, nbOfItemsInRow)
        : items;
    return (React.createElement("ul", { className: `list:none d:inline-flex fxw:wrap:xl-up scrbar:none ov:y:h ox:x:a ${styles.items}`, ref: containerRef },
        viewAllObj !== undefined &&
            React.createElement("li", { className: `pos:r bdrs:1 ${styles.itemWrapper} ${styles.order1}` },
                React.createElement(Link, { to: { pathname: `/collections/${viewAllObj.handle}${medium !== undefined ? `/${medium}` : ''}`, search: searchParamsStr.length > 0 ? `?${searchParamsStr}` : '' }, className: `d:flex ai:center fw:700 lts:002 text:break-spaces w:max-content ${styles.viewAll}`, onClick: () => {
                        dispatchGAEvent('Collection', 'click', `Subcollections : view all : ${viewAllObj.fullName}`);
                    } },
                    "VIEW ALL ",
                    '\n',
                    viewAllObj.name.toUpperCase())),
        MEDIA_BREAKPOINTS.XL_UP.matches && nbOfItemsInRow !== items.length &&
            React.createElement("li", { className: `pos:r bdrs:1 ${styles.itemWrapper} ${styles.order3}` },
                React.createElement("button", { className: `btn:cleared d:flex ai:center jc:center w:max-content ${styles.item} ${styles.expandButton}`, onClick: () => {
                        setExpanded(!expanded);
                        dispatchGAEvent('Collection', 'click', `Subcollections : ${expanded ? 'collapse' : 'expand'} items`);
                    } },
                    expanded ? '-' : '+',
                    " ",
                    items.length - nbOfItemsInRow)),
        itemsForRender.map(({ handle, facetKey, facetValue, name, fullName, image }) => {
            const nbOfItems = facetsFromServer[facetKey][facetValue];
            const lazySrc = getLazyLinkToImage(image);
            return (React.createElement("li", { key: handle, className: `pos:r bdrs:1 ${styles.itemWrapper} ${styles.order2}` },
                React.createElement(Link, { to: { pathname: `/collections/${handle}${medium !== undefined ? `/${medium}` : ''}`, search: searchParamsStr.length > 0 ? `?${searchParamsStr}` : '' }, className: `d:flex ai:center fw:700 lts:002 text:break-spaces w:max-content ${styles.item} ${styles.collection}`, onClick: () => {
                        dispatchGAEvent('Collection', 'click', `Subcollections : view all : ${fullName}`);
                    } },
                    React.createElement("img", { src: image, srcSet: `${lazySrc.replace('{width}', '73')} 1x, ${lazySrc.replace('{width}', '146')} 2x, ${lazySrc.replace('{width}', '219')} 3x`, alt: `${name} ${kw1}`, height: 73, width: 73, loading: "lazy", sizes: "4.5625", className: `image:cover skeleton ${styles.collectionImg}` }),
                    React.createElement("span", { className: `text:uppercase fw:700 fw:400:lg-up lts:002 ${styles.collectionTitle}` },
                        name.includes(' ')
                            ? `${name.replace(/ ([^ ]*)$/, '\n' + '$1')} `
                            : `${name}\n`,
                        React.createElement("span", { className: "fw:400" },
                            "(",
                            nbOfItems,
                            ")")))));
        })));
};
